import { POPUP_DIMENSIONS } from '@misc/constants'
import { Wallet } from '@plug-core/providers/WalletProvider'
import { getOnramperUrl } from '@plug-core/utils/onramperUrl'
import { isSidePanel } from './windows'

const getPopupParams = () => {
  const props = {
    popup: true,
    height: POPUP_DIMENSIONS.height + 28,
    width: POPUP_DIMENSIONS.width,
    top: 0,
    left: 0,
  }

  if (!isSidePanel) {
    let left = window.screenX - POPUP_DIMENSIONS.width + 3
    if (left < 0) {
      left = window.screenX + POPUP_DIMENSIONS.width + 10
    }

    props.top = window.screenY - 23
    props.left = left
  } else {
    props.top = window.screenY + window.outerHeight - window.innerHeight - 28
    props.left = window.screenX + window.outerWidth - POPUP_DIMENSIONS.width
  }

  return Object.entries(props)
    .map(([k, v]) => `${k}=${v}`)
    .join(',')
}

export const openOnramper = async (wallet: Wallet, defaultCrypto: string = 'icp_icp') => {
  const url = await getOnramperUrl(wallet, defaultCrypto)
  window.open(url, '_blank', getPopupParams())
}
